<template>
  <v-container>
    <v-row>
      <v-col 
        v-for="(comp, index) in types[type].comps" 
        :key="index" 
        :cols="calcCol(types[type].comps.length)" 
        class="center no-padding">
        <v-col cols="12" class="no-padding">
          <component 
            :is="comp.comp"
            :task="item.Tasks[0]"
            :item="item"
            :job-type="type"
            @toggleAssignmentComp="toggleAssignmentComp"
          />
        </v-col>
        <v-col cols="12" class="no-padding">
          <span class="action-label">{{comp.label}}</span>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { Logger } from "aws-amplify"
const logger = new Logger("TaskActions")

import OTC from './OTC';
import StatusTableWrapper from './StatusTableWrapper';
import DeviceAssignment from './DeviceAssignment';

export default {
  name: 'TaskActions',
  components: {
    OTC,
    StatusTableWrapper,
    DeviceAssignment
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      types: {
        taskinstall: {
          comps: [
            {
              comp: 'OTC',
              label: 'View OTCs'
            },
            {
              comp: 'DeviceAssignment',
              label: 'Assign Vehicle'
            }
          ]
        },
        device_config: {
          comps: [
            {
              comp: 'StatusTableWrapper',
              label: 'View Status'
            }
          ]
        },
        firmwareupdate: {
          comps: [
            {
              comp: 'StatusTableWrapper',
              label: 'View Status'
            }
          ]
        }
      }
    }
  },
  methods: {
    toggleAssignmentComp(task) {
      this.$emit('toggleAssignmentComp', task);
    },
    calcCol(count) {
      logger.info('testing calcCol : ', count % 2)
      return count % 2 == 0 ? 6 : 12;
    } 
  }
}
</script>

<style lang="scss">
  .center {
    text-align: center;
  }
  .no-padding {
    padding: 0;
  }
  .action-label {
    font-size: 12px;
  }
</style>